import {
  Add as AddIcon,
  DeleteTwoTone as DeleteTwoToneIcon
} from '@mui/icons-material';
import { Box, Button, Tooltip } from '@mui/material';

import { useTranslations } from 'context/TranslationContext';

import {
  gridToolbarStyle,
  toolbarButtonStyle,
  toolbarIconsStyle
} from 'styles/components/DataGridStyle';

interface CounterpartiesToolbarProps {
  readonly deleteDisabled: boolean;
  readonly deleteTooltip: string;
  readonly onAdd: () => void;
  readonly onDelete: () => void;
}

export const CounterpartiesToolbar = ({
  deleteDisabled,
  deleteTooltip,
  onAdd,
  onDelete
}: CounterpartiesToolbarProps) => {
  const { translate } = useTranslations();

  return (
    <Box
      sx={{
        ...gridToolbarStyle,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap'
        }}
      >
        <Tooltip title={deleteTooltip}>
          <span>
            <Button
              color="error"
              disabled={deleteDisabled}
              startIcon={<DeleteTwoToneIcon sx={toolbarIconsStyle} />}
              onClick={onDelete}
              sx={toolbarButtonStyle}
            >
              {translate('buttons.delete')}
            </Button>
          </span>
        </Tooltip>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexWrap: 'wrap',
          ml: 'auto'
        }}
      >
        <Tooltip title={translate('messages.manageGroupsComingSoon')}>
          <span>
            <Button
              disabled
              sx={{
                ...toolbarButtonStyle,
                fontSize: {
                  xs: '0.61rem',
                  sm: '0.61rem',
                  md: '0.7rem',
                  lg: '0.875rem'
                }
              }}
            >
              {translate('addCounterparty.manageGroups')}
            </Button>
          </span>
        </Tooltip>

        <Button
          color="primary"
          startIcon={<AddIcon sx={toolbarIconsStyle} />}
          onClick={onAdd}
          sx={toolbarButtonStyle}
        >
          {translate('buttons.add')}
        </Button>
      </Box>
    </Box>
  );
};
